import { useRef } from 'react'
import { useSelector } from 'react-redux'
import { selectFeatureFlag, selectFeatureFlagsSettled } from '../features/featureFlags/selectors'
import { AUTH_NEUTRAL_LOGIN } from '../config/featureFlagKeys'

const useNeutralLogin = () => {
  const live = useSelector(selectFeatureFlag(AUTH_NEUTRAL_LOGIN))
  const settled = useSelector(selectFeatureFlagsSettled)
  const firstAnswer = useRef(null)

  if (settled && firstAnswer.current === null) firstAnswer.current = live

  return { ready: settled, neutral: firstAnswer.current ?? live }
}

export default useNeutralLogin
